import { kgToLbs, lbsToKg, cmToFtIn, ftInToCm } from "../dataStore"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  getConvertedWeights() {
    if (!this.store.isMetric) {
      if (!this.formValues.weightKg) return
      const { weightKg } = this.formValues

      const weightLbs = Math.round(kgToLbs(weightKg))

      return weightLbs
    } else {
      if (!this.formValues.weightLbs) return
      const { weightLbs } = this.formValues

      const weightKg = Math.round(lbsToKg(weightLbs))

      return weightKg
    }
  },

  getConvertedHeights() {
    if (!this.store.isMetric) {
      if (!this.formValues.heightCm) return
      const { heightCm } = this.formValues

      const imperialHeight = cmToFtIn(heightCm)
      const heightFt = imperialHeight.heightFt
      const heightIn = imperialHeight.heightIn

      return { heightFt, heightIn }
    } else {
      if (!this.formValues.heightFt || !this.formValues.heightIn) return
      const { heightFt, heightIn } = this.formValues

      const heightCm = ftInToCm({ ft: heightFt, inch: heightIn })

      return heightCm
    }
  },

  convertHeight() {
    if (!this.store.isMetric) {
      const { heightFt, heightIn } = this.getConvertedHeights()

      this.formValues.heightFt = heightFt
      this.formValues.heightIn = heightIn
    } else {
      const heightCm = this.getConvertedHeights()

      this.formValues.heightCm = heightCm
    }
  },

  convertWeight() {
    if (!this.store.isMetric) {
      const weightLbs = this.getConvertedWeights()

      this.formValues.weightLbs = weightLbs
    } else {
      const weightKg = this.getConvertedWeights()

      this.formValues.weightKg = weightKg
    }
  },

  processFormValues() {
    const { age, firstName, heightCm, heightFt, heightIn, weightKg, weightLbs } = this.formValues

    if (this.store.isMetric) {
      const imperialHeight = cmToFtIn(heightCm)
      const convertedHeightFt = imperialHeight.heightFt
      const convertedHeightIn = imperialHeight.heightIn
      const convertedWeightLbs = Math.round(kgToLbs(weightKg))

      return {
        heightFt: convertedHeightFt,
        heightIn: convertedHeightIn,
        heightCm,
        weightLbs: convertedWeightLbs,
        weightKg,
        age,
        firstName,
      }
    } else {
      const convertedHeightCm = ftInToCm({ ft: heightFt, inch: heightIn })
      const convertedWeightKg = Math.round(lbsToKg(weightLbs))

      return {
        age,
        firstName,
        heightCm: convertedHeightCm,
        heightFt,
        heightIn,
        weightKg: convertedWeightKg,
        weightLbs,
      }
    }
  },

  getButtonState() {
    const { age, heightCm, heightFt, heightIn, weightKg, weightLbs, firstName } = this.formValues

    if (this.store.isMetric) {
      this.showButton = !!(heightCm || heightCm === 0) && !!(weightKg || weightKg === 0)
    } else if (this.store.isImperial) {
      this.showButton =
        !!(heightFt || heightFt === 0) &&
        (heightIn || heightIn === 0) &&
        !!(weightLbs || weightLbs === 0)
    }
    this.showButton = !!(age || age === 0) && !!firstName
  },
})
